import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';
import { HeaderParameters } from '../components';
import { useCompany, useCompanyFunctions } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import BlockWithoutStepModal, { ENDING_LOCATIONS } from 'components/BlockWithoutStepModal';
import CompanyDetailsForm from 'components/CompanyDetailsForm';
import logoCompanyDetails from '_assets/parameters/settings.svg';
import routes from 'config/routes';
import useStyles from './styles';

const NoteDescriptif = () => {
  const classes = useStyles();
  const history = useHistory();

  const { currentCompany, companySteps, companyStepLoading } = useCompany();
  const { editCompanyDetails } = useCompanyFunctions();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPageBlocked, setIsPageBlocked] = useState(false);

  useEffect(() => {
    setIsPageBlocked(!companySteps.description_created);
  }, [companySteps]);

  const handleBlockedPageClose = () => {
    history.push(routes.home.root);
  };

  const handleSubmit = async (values) => {
    return await editCompanyDetails(currentCompany, values);
  };

  return !!companyStepLoading ? (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={100} />
    </div>
  ) : (
    <>
      <Grid className={classes.root} container direction="column">
        <Grid className={classes.title} container item xs={12} justifyContent="center">
          <HeaderParameters image={logoCompanyDetails} noMargin isSubmitting={isSubmitting} text="Note et Descriptif" />
        </Grid>

        <CompanyDetailsForm setSubmitting={setIsSubmitting} onSubmit={handleSubmit} />
      </Grid>
      <BlockWithoutStepModal
        endingLocation={ENDING_LOCATIONS.description}
        open={isPageBlocked}
        onClose={handleBlockedPageClose}
      />
    </>
  );
};

export default NoteDescriptif;
